import {type MouseEvent, useCallback, useEffect, useState} from 'react';
import type {NativeSyntheticEvent, NativeTouchEvent} from 'react-native';

import type {ClickEventPayload, Props} from './types';

import {createEventNormalizer} from '../../utils/events';

export const useController = ({
  checked: checkedProp,
  controlled,
  disabled,
  onClick,
}: Props) => {
  const [checked, setChecked] = useState(checkedProp);

  useEffect(() => {
    if (!controlled) {
      setChecked(checkedProp);
    }
  }, [checkedProp, controlled]);

  const clickHandler = useCallback(
    event => {
      if (disabled) {
        return;
      }

      const newValue = controlled ? !checked : checkedProp;

      const normalized = eventNormalizer(event, {checked: Boolean(newValue)});

      onClick?.(normalized);

      setChecked(newValue);
    },
    [checked, checkedProp, controlled, disabled, onClick],
  );

  return {checked, clickHandler};
};

const eventNormalizer = createEventNormalizer<
  MouseEvent,
  NativeSyntheticEvent<NativeTouchEvent>,
  ClickEventPayload
>();
